import styles from '../UploadConfigModal.module.scss';
import { UploadConfigFileItem } from '../UploadConfigFileItem/UploadConfigFileItem'

interface UploadConfigFileListProps {
    files: File[]
    configNames: string[]
    onFileNameSelect: (idx: number, name: string) => void
    onFileDelete: (idx: number) => void
    selectedConfigNames: Record<string, string>
}

export const UploadConfigFileList = (props: UploadConfigFileListProps) => {
    const { files, configNames, onFileNameSelect, onFileDelete, selectedConfigNames } = props

    return (
        <div className={styles.fileList}>
            {files.map((file: File, idx) => (
                <UploadConfigFileItem
                    key={file.name}
                    idx={idx}
                    fileName={file.name}
                    onFileNameSelect={onFileNameSelect}
                    onFileDelete={onFileDelete}
                    configNames={configNames}
                    selectedConfigName={selectedConfigNames[idx]}
                />
            ))}
        </div>
    )
}